export const CHANGELOG_ACTIVITY = "CHANGELOG_ACTIVITY";

export const CHANGELOG_DOCUMENT_MODEL = "Changelog_D";
